import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {Site, SiteList} from '../domain/site';

@Injectable({
  providedIn: 'root'
})
export abstract class ItemSummarySiteListService {
  data = {
    siteList: new SiteList(),
    sites: []
  };
  siteListCallback: Subject<Site[]> = new Subject<Site[]>();

  protected constructor() {
  }

  abstract getSiteList(): void;

  abstract getSites(): Site[];
}
